export default defineAppConfig({
  ui: {
    colors: {
      // Dynamic palettes from SCSS presets
      primary: 'primary',
      secondary: 'secondary',
      neutral: 'zinc',
    },
    button: {
      compoundVariants: [
        {
          color: 'neutral',
          variant: 'solid',
          class:
            'text-inverted bg-[#3f3f47] hover:bg-[#52525b] active:bg-[#52525b] disabled:bg-[#3f3f47] aria-disabled:bg-[#3f3f47] focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#3f3f47]',
        },
      ],
    },
    pagination: {
      compoundVariants: [
        {
          color: 'neutral',
          variant: 'solid',
          class:
            'text-inverted bg-[#3f3f47] hover:bg-[#52525b] active:bg-[#52525b] disabled:bg-[#3f3f47] aria-disabled:bg-[#3f3f47]',
        },
      ],
    },
    navigationMenu: {
      variants: {
        active: {
          true: {
            link: 'sidebar-nav-active',
            linkLeadingIcon: 'sidebar-nav-active',
            childLink: 'sidebar-nav-active',
          },
          false: {
            link: 'sidebar-nav-item',
            linkLeadingIcon: 'sidebar-nav-item-icon',
            childLink: 'sidebar-nav-item',
          },
        },
      },
    },
    dashboardSearchButton: {
      slots: {
        base: 'sidebar-search',
      },
    },
  },
})
